var bin = angular.module('bin');
bin.service('BinService', function($http, $location, $cookieStore) {

    var sort = {};
    var activeBin = null;
    var appFilter = '';
    var setFilter = function(filter, data) {
        var temp = $cookieStore.get('filter');
        if (typeof temp === 'undefined') {
            this.initFilter();
            temp = $cookieStore.get('filter');
        }
        temp[filter] = data;
        $cookieStore.put('filter', temp);
    }

    var searchByAlpha = function(alpha) {
        this.appFilter = alpha;
    }

    var setSort = function(field, reverse)
    {
        var temp = $cookieStore.get('sort');
        temp.field = field;
        temp.reverse = reverse;
        $cookieStore.put('sort', temp);
    }

    var getSort = function()
    {
        if (typeof $cookieStore.get('sort') === "undefined")
        {
            initSort();
        }
        return $cookieStore.get('sort');
    }

    var initSort = function()
    {
        sort.field =  "Applicants";
        sort.reverse = false;
        $cookieStore.put('sort', sort);

    }

    var setBin = function(bin) {
        activeBin = bin;
    }

    var getBin = function() {
        if (typeof activeBin === 'undefined' || activeBin == null)
            return 'Applications';
        else if (activeBin=='Reject')
            return "Non-Awarded"
        return activeBin;
    }

    var initTaxFilter = function()
    {
        var taxFilter =
        {
            'field': 'taxStatusClass',
            'values':
            {
                'pending': false,
                'not-received': false,
                'missing-information': false,
                'verified': false
            }
        }
        return taxFilter;
    }

    var initGradeFilter = function()
    {
        var gradeFilter =
        {
            'field': 'Division_Code',
            'values': {}
        };
        return gradeFilter;
    }

    var initNRFilter = function()
    {
        var NRFilter =
        {
            'field': 'NR_Choice',
            'values':
            {
                '1': false,
                '2': false,
                '0': false
            }
        }
        return NRFilter;
    }

    var initCategoriesFilter = function()
    {
        var SubCatsFilter =
        {
            'field': 'SubCat_IDs',
            'values': {}
        }
        return SubCatsFilter;
    }

    var initAccountsFilter = function()
    {
        var accountsFilter =
        {
            'field': 'accountID',
            'values': {}
        }
        return accountsFilter;
    }
    var updateFilter = function(filter)
    {
        this.setFilter(filter, this.filter[filter]);
    }

    var initFilter = function()
    {
        var filter = {};
        filter.taxFilter = initTaxFilter();
        filter.gradeFilter = initGradeFilter();
        filter.NRFilter = initNRFilter();
        filter.SubCatsFilter = initCategoriesFilter();
        filter.accountsFilter = initAccountsFilter();
        $cookieStore.put('filter', filter);
    }

    if (typeof $cookieStore.get('filter') === "undefined")
    {
        initFilter();
    }
    var filter = $cookieStore.get('filter');


    var iconClass = function(header)
    {
        var sort = getSort();
        if (activeClass(header) == 'active')
        {
            if (sort.reverse)
                return 'ion-ios7-arrow-down';
            else
                return 'ion-ios7-arrow-up';
        }
        return '';
    }

    var activeClass = function(header)
    {
        var sort = getSort();
        if (sort.field.toString() == header.toString())
            return 'active'
        return ''
    }

    return {
        appFilter: appFilter,
        setFilter: setFilter,
        searchByAlpha: searchByAlpha,
        filter: filter,
        setSort: setSort,
        getSort: getSort,
        updateFilter: updateFilter,
        iconClass: iconClass,
        activeClass: activeClass,
        initFilter: initFilter,
        setBin: setBin,
        getBin: getBin
    }
});
/* End binService Service */
